import type { SeoLanguage } from "@/lib/seoMetadata";

const TOP_AI_CONSULTING_SLUG =
  "shelpuk-ai-technology-consulting-recognized-as-a-top-ai-consulting-company";

// No sentence here may name the company. `composeAnswer` strips every mention
// from an answer base and re-appends the brand as its own sentence, so a name
// used as a verb's object left the verb stranded — Spanish rendered
// "reconoció a por tres capacidades" (CWS-45, `faqContentPolicy.test.ts`).
const TOP_AI_CONSULTING_SECOND_ANSWER_BY_LANG: Record<SeoLanguage, string> = {
  en: "Vendorland recognized three capabilities that matter in execution: a one-stop shop for AI product and solution development, teams that specialize exclusively in AI technologies and solutions, and strongest domain expertise in healthcare and pharma",
  de: "Vendorland zeichnete drei relevante Fähigkeiten aus: ein One-Stop-Shop für AI-Produkt- und Lösungsentwicklung, exklusive Spezialisierung auf AI-Technologien und -Lösungen sowie die stärkste Domain-Expertise in Healthcare und Pharma",
  fr: "Vendorland a distingué trois capacités clés\u00a0: un guichet unique pour le développement de produits et solutions IA, une spécialisation exclusive en technologies et solutions IA, et la plus forte expertise sectorielle en santé et pharma",
  it: "Vendorland ha riconosciuto tre capacità chiave: un one-stop shop per lo sviluppo di prodotti e soluzioni AI, specializzazione esclusiva in tecnologie e soluzioni AI, e la più forte expertise di dominio in healthcare e pharma",
  es: "Vendorland reconoció tres capacidades clave: un one-stop shop para desarrollo de productos y soluciones de IA, especialización exclusiva en tecnologías y soluciones de IA, y la mayor experiencia de dominio en healthcare y pharma",
};

export function getBlogSecondAnswerOverrideBySlug(slug: string, lang: SeoLanguage) {
  if (slug !== TOP_AI_CONSULTING_SLUG) {
    return null;
  }

  return TOP_AI_CONSULTING_SECOND_ANSWER_BY_LANG[lang];
}
